import React from 'react';
import { FacebookShareButton, InstapaperShareButton } from 'react-share';

import { Stack } from '../Core';
import FacebookIcon from '../SVG/FacebookIcon';
import InstagramIcon from '../SVG/InstagramIcon';

const SocialShareIcons = ({ location }: { location: string }) => (
  <Stack isInline className="space-x-8">
    <FacebookShareButton url={location}>
      <FacebookIcon className="w-6 h-6" />
    </FacebookShareButton>
    <InstapaperShareButton url={location}>
      <InstagramIcon className="w-6 h-6" />
    </InstapaperShareButton>
  </Stack>
);

export default SocialShareIcons;